// #  Import resoureces
import React from 'react'
import { Route, IndexRoute } from 'react-router'
  // #  Primary usage is for loading other scripts
import loadScript from '../../core/engine/helpers/load-script';
  // #  Basics object
import {basics} from '../../core/engine/helpers/basics';
import {user} from '../../core/controllers/user';
import {helper} from '../../helpers/';
// #  Import components and views
import Routes from './Routes.jsx'
import Login from '../../views/Login/'
import Signup from '../../views/Signup/'
import Forgot from '../../views/Forgot/'
import Home from '../../views/Home/'
import Groups from '../../views/Groups/'
import Group from '../../views/Group/'
import Tenants from '../../views/Tenants/'
import Tenant from '../../views/Tenant/'
import SetupPaymentPlan from '../../views/Tenants/PaymentPlans/'
import Screening from '../../views/Tenant/Screening/'
import LeadScreening from '../../views/Lead/Screening/'
import Documents from '../../views/Documents/'
import Leases from '../../views/Leases/'
import Lease from '../../views/Lease/'
import LeaseTenant from '../../views/LeaseTenant'
import Users from '../../views/Users/'
import User from '../../views/User/'
import BuildingsDashboard from '../../views/Buildings/'
import Settings from '../../views/Settings/'
import Activity from '../../views/Activity/'
import Billing from '../../views/Billing/'
import CreditCard from '../../views/CreditCard/'
import BankAccount from '../../views/BankAccount/';
import PayOnline from '../../views/PayOnline/'
import PaymentForm from '../../views/Tenant/PaymentForm/'
import Account from '../../views/Account/'
import Subscription from '../../views/Subscription'
import Maintenance from '../../views/Maintenance/'
import Payables from '../../views/Payables/'
import Vendor from '../../views/Payables/Vendor'
import VendorBill from '../../views/Payables/Bill'
import WorkOrder from '../../views/WorkOrder/'
import Financial from '../../views/Financial/'
/* move BuildingOverview to View/Building/Overview */
import BuildingOverview from '../../views/BuildingOverview/'
import BuildingNew from '../../views/Building/New/'
import LevelEditor from '../../views/LevelEditor/'
import Reports from '../../views/Reports/'
import Leads from '../../views/Leads/'
import Lead from '../../views/Lead/'
import GetStarted from '../../views/GetStarted/'
import Insurance from '../../views/Insurance/'
import Warranty from '../../views/Warranty'
import WarrantyEdit from '../Warranty/WarrantyEdit';

import Collaborator from '../../views/Collaborator';
import ElectronicLeaseSigning from '../../views/Signature'

import AdminUsers from '../../views/Admin/Users/'
import AdminUser from '../../views/Admin/User/'
import AdminTenants from '../../views/Admin/Tenants/'
import AdminAdmins from '../../views/Admin/Admins/'
import AdminAdmin from '../../views/Admin/Admin/'
import AdminSubscriptions from '../../views/Admin/Subscriptions/'
import AdminSubscription from '../../views/Admin/Subscription/'
import AdminIntegrations from '../../views/Admin/Integrations/'
import AdminTransactions from '../../views/Admin/Transactions/'
import AdminOwners from '../../views/Admin/Owners/'
import AdminContractors from '../../views/Admin/Contractors/'
import AdminSensors from '../../views/Admin/Sensors/'
import Property from '../../views/Property';
import Properties from '../../views/Properties';
import Listings from '../../views/Listings';
import Listing from '../../views/Listing';
import PublicListings from '../../views/Listings/Public/'
import Owners from '../../views/Owners';
import Owner from '../../views/Owner';
import RentersInsurance from '../../views/Tenant/RentersInsurance';
import Payout from '../../views/Payout';
import Charge from '../../views/Tenants/Charge';
import Credit from '../../views/Tenants/Credit';
import QuickBooks from '../../views/QuickBooks';
import VendorSignIn from '../../views/Vendor';
import VendorBillView from '../../views/VendorView/VendorBill'

function startLoader(previous, replace) {
  if ((previous.components[1].displayName == 'LevelEditor' && replace.routes[1].component.displayName == 'LevelEditor')) {
  } else {
    basics.resetLoader();
  }

  if((replace.location.pathname != '/login' && replace.location.pathname != '/signup' && replace.location.pathname != '/screen' && replace.location.pathname != '/vendor/login') && user.userInfo == null) {
    user.getUserData();
  }
};
/*loadScript('assets/js/fakeLoader.min.js', () => {
  var preLooaderOptions = {
    timeToHide:1500, //Time in milliseconds for fakeLoader disappear
    zIndex:"999",//Default zIndex
    spinner:"spinner4",//Options: 'spinner1', 'spinner2', 'spinner3', 'spinner4', 'spinner5', 'spinner6', 'spinner7'
    bgColor:"#1E425D" //Hex, RGB or RGBA color 
  };
  $(".global_preloader").fakeLoader(preLooaderOptions);
});*/
// #  Build internal routing
let route =
<Route path="/" component={Routes} onChange={startLoader}>
  <Route path="/getstarted" component={GetStarted}/>
  <Route path="/login" component={Login}/>
  <Route path="/screen" component={LeadScreening}/>
  <Route path="/signature" component={ElectronicLeaseSigning} />
  <Route path="/listings/:slug" component={PublicListings} />
  <Route path="/signup" component={Signup}/>
  <Route path="/forgot" component={Forgot}/>
  <Route path="/logout" />
  <IndexRoute title="Dashboard" component={Home}/>
  <Route path="/buildings"  component={BuildingsDashboard}/>
  <Route path="/building/new" component={BuildingNew}/>
  <Route path="/building/:buildingID" component={BuildingOverview}/>
  <Route path="/building/:buildingID/level/:levelID" component={LevelEditor}/>
  <Route path="/building/:buildingID/level/:levelID/space/:spaceID" component={LevelEditor}/>
  <Route path="/building/:buildingID/level/:levelID/sensor/:spaceID" component={LevelEditor}/>
  <Route path="/groups" component={Groups}/>
  <Route path="/group/:groupID" component={Group}/>
  <Route path="/financial" component={Financial} />
  <Route path="/quickbooks" component={QuickBooks} />
  <Route path="/tenants" component={Tenants}/>
  <Route path="/tenants/paymentplan" component={SetupPaymentPlan}/>
  <Route path="/tenant/:tenantID" component={Tenant}/>
  <Route path="/tenant/:tenantID/screen" component={Screening}/>
  <Route path="/request/renters" component={RentersInsurance}/>
  <Route path="/documents" component={Documents}/>
  <Route path="/leases" component={Leases}/>
  <Route path="/lease" component={LeaseTenant}/>
  <Route path="/lease/:leaseID" component={Lease}/>
  <Route path="/lease/:leaseID/movein" component={Lease} customAction="movein"/>
  <Route path="/lease/:leaseID/moveout" component={Lease} customAction="moveout"/>
  <Route path="/users" component={Users}/>
  <Route path="/user/:userAccountID" component={User}/>
  <Route path="/maintenance" component={Maintenance}/>
  <Route path="/maintenance/order/:workOrderID" component={WorkOrder} />
  <Route path="/payables" component={Payables} />
  <Route path="/payables/vendors/:vendorId" component={Vendor}/>
  <Route path="/payables/bills/:vendorBillId" component={VendorBill}/>
  <Route path="/vendor/login" component={VendorSignIn} />
  <Route path="/settings" component={Settings} settingComponent="" />
  <Route path="/settings/buildings/spaces/colorcodes" component={Settings} settingComponent="spacesColorCode"/>
  <Route path="/settings/buildings/levels/statelisteners" component={Settings} settingComponent="levelStateListeners"/>
  <Route path="/settings/notifications" component={Settings} settingComponent="notifications"/>
  <Route path="/settings/fees" component={Settings} settingComponent="fees"/>
  <Route path="/settings/quickbooks" component={Settings} settingComponent="qbenterprise"/>
  <Route path="/settings/integrations" component={Settings} settingComponent="integrations" />
  <Route path="/settings/import" component={Settings} settingComponent="import" />
  <Route path="/settings/referral" component={Settings} settingComponent="referral" />
  <Route path="/activity" component={Activity}/>
  <Route path="/account/billing" component={Billing}/>
  <Route path="/account/billing/new" component={BankAccount}/>
  <Route path="/account/billing/:id" component={BankAccount}/>
  <Route path="/account/billing/cc/new" component={CreditCard}/>
  <Route path="/account/billing/cc/:id" component={CreditCard}/>
  <Route path="/subscription" component={Subscription}/>
  <Route path="/account"  component={Account}/>
  <Route path="/account/payonline"  component={PayOnline}/>
  <Route path="/account/payonlineform" component={PaymentForm}/>
  <Route path="/reports"  component={Reports}/>
  <Route path="/warranty"  component={Warranty}/>
  <Route path="/warranty/:warrantyId" component={WarrantyEdit} />
  <Route path="/leads" component={Leads} />
  <Route path="/lead/:leadId" component={Lead} />
  <Route path="/collaborator" component={Collaborator} />
  <Route path="/properties" component={Properties} />
  <Route path="/properties/:propertyId" component={Property}/>
  <Route path="/listings" component={Listings} />
  <Route path="/listing/:listingId" component={Listing}/>
  <Route path="/owners" component={Owners} />
  <Route path="/owners/:payouts" component={Owners} />
  <Route path="/owner/:ownerId" component={Owner}/>
  <Route path="/owner/payout/:payoutId" component={Payout}/>
  <Route path="/tenant/charge/:chargeId" component={Charge}/>
  <Route path="/tenant/credit/:creditId" component={Credit}/>
  <Route path="/insurance/request" component={Insurance}/>
  <Route path="/admin/users" component={AdminUsers}/>
  <Route path="/admin/user/:userId" component={AdminUser}/>
  <Route path="/admin/contractors" component={AdminContractors}/>
  <Route path="/admin/admins" component={AdminAdmins}/>
  <Route path="/admin/admin/:adminId" component={AdminAdmin}/>
  <Route path="/admin/tenants" component={AdminTenants}/>
  <Route path="/admin/subscriptions" component={AdminSubscriptions}/>
  <Route path="/admin/subscription/:subscriptionId" component={AdminSubscription}/>
  <Route path="/admin/transactions" component={AdminTransactions}/>
  <Route path="/admin/owners" component={AdminOwners}/>
  <Route path="/admin/integrations" component={AdminIntegrations}/>
  <Route path="/admin/sensors" component={AdminSensors}/>
  <Route path="/bills" component={VendorBillView} />
  <Route path="*" component={Home} notFound={true}/>
</Route>;

export default route;



// WEBPACK FOOTER //
// app/components/Routes/index.js